module.exports = __webpack_public_path__ + "img/nologo2.48d024a6.png";